<template>
  <div style="width: 130px">
    <a-input-number style="margin-right: 30px" v-bind="$attrs" :id="idIpt" @change="iptChange" @keydown.enter="iptEnter"
      :min="min" :max="max < 0 ? 0 : max" />
  </div>
</template>

<script>
import { InputNumber } from "ant-design-vue";
import 'ant-design-vue/lib/input-number/style/css';
export default {
  name: "IptNumber",
  components: {
    [InputNumber.name]: InputNumber
  },
  props: {
    unit: {
      type: String,
      default: _ => '件'
    },
    min: {
      type: Number,
      default: _ => 0
    },
    max: {
      type: Number,
      default: _ => 100000000000
    }
  },
  data() {
    return {
      val: '',
      idIpt: Math.random().toFixed(8)
    }
  },
  mounted() {
    this.$nextTick(_ => {
      // console.log(document.getElementById(this.idIpt).parentNode.parentNode)
      if (document.getElementById(this.idIpt)) {
        document.getElementById(this.idIpt).parentNode.parentNode.setAttribute('data-unit', this.unit) // 提供个 css before content attr 使用
      }
    })
  },
  methods: {
    iptChange: function (val) {
      this.val = val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    iptEnter: function () {
      this.$emit('enter', this.val)
    },
    focus: function () {
      // console.log('$refs', this)
      document.getElementById(this.idIpt).focus()
    },
    blur: function () {
      // console.log('$refs', this)
      document.getElementById(this.idIpt).blur()
    }
  }
}
</script>

<style scoped>
::v-deep .ant-input-number {
  width: 100px;
  position: relative;
  top: 0;
  left: 0;
  border-radius: 4px 0 0 4px;
}

::v-deep .ant-input-number::before {
  content: attr(data-unit);
  /* 动态获取 标签内的 data-value*/
  display: block;
  position: absolute;
  top: 0;
  right: -26px;
  bottom: 0;
  margin: auto 0;
  font-size: 14px;
  line-height: 32px;
  font-weight: 600;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-left-color: transparent;
  border-radius: 0 4px 4px 0;
  padding: 0 5px;
  background: #fafafa;
}

::v-deep .ant-input-number:hover {
  border-right-color: #d9d9d9;
}

::v-deep .ant-input-number:hover::before {
  border-color: #40a9ff;
  border-left-color: transparent;
}

::v-deep .ant-input-number-focused {
  border-right-color: transparent;
}

::v-deep .ant-input-number-focused::before {
  border-color: #40a9ff;
  border-left-color: transparent;
  box-shadow: 2px 0 2px 2px rgba(64, 169, 255, 0.25);
}


::v-deep .ant-input-number-handler-wrap{
  opacity: 1;
}
</style>
